export const DEFAULT_INPUT_TEXT = 'Заезд – Выезд';
export const CHECKOUT_ONLY_TOOLTIP_MESSAGE = 'Доступен только выезд';

interface IUpdateDailyrentUrlParameters {
  currentUrl: string;
  dates?: { checkin?: string; checkout?: string };
  guestsCount?: number;
}

export const updateDailyrentUrlParameters = ({
  currentUrl,
  dates,
  guestsCount,
}: IUpdateDailyrentUrlParameters): string => {
  const url = new URL(currentUrl);

  if (dates && dates.checkin && dates.checkout) {
    url.searchParams.set('checkin', dates.checkin);
    url.searchParams.set('checkout', dates.checkout);
  }

  if (guestsCount && guestsCount > 1) {
    url.searchParams.set('min_beds', String(guestsCount));
  } else {
    url.searchParams.delete('min_beds');
  }

  return url.toString();
};

type TDailyrentQueryParams = 'checkin' | 'checkout' | 'min_beds';

export const deleteDailyrentQueryParams = (currentUrl: string, paramsToDelete: TDailyrentQueryParams[]) => {
  const url = new URL(currentUrl);

  paramsToDelete.forEach(p => {
    url.searchParams.delete(p);
  });

  return url.toString();
};
